<template>
  <div class="gantt-leftbar">
    <div class="gantt-leftbar-item gantt-block-top-space"
         :style="{height:topSpace+'px'}">
    </div>
    <div class="gantt-leftbar-item"
         :style="cellHeightStyle(data)"
         v-for="(data,index) in datas"
         :key="dataKey?data[dataKey]:index">
      <slot :data="data">
        <div class="gantt-leftbar-defalutItem">need slot</div>
      </slot>
    </div>
  </div>
</template>
  
<script>
import dr from '../dynamic-render.js'
export default {
  name: "LeftBar",
  mixins: [dr],
  props: {
    dataKey: String,
    datas: {
      type: Array,
      required: true
    }
  },
  methods: {
    cellHeightStyle (data) {
      let cellHeight = 30 * data['totalRow'];
      return {
        'height': `${cellHeight}px`
      }
    }
  }
};
</script>